/**
 * Models for Engagement-to-Voting Mapping Records
 * These represent the linkage between engagement activities and voting decisions
 */

export interface EngagementVotingMappingRecord {
  compass_cid: string;
  company_name: string;
  voting_record_id: string;
  engagement_record_id: string;
  confidence_score: number;
  rationale: string;
  is_cross_manager: boolean;
  matching_factors: string;
  interaction_class: InteractionClass;
  interaction_class_rationale: string;
  linkage_type: LinkageType;
  linkage_type_rationale: string;
  sequence_flow: SequenceFlow;
  sequence_flow_rationale: string;
  run_id: string;
  run_timestamp: string;
}

export enum InteractionClass {
  CONSISTENT_REINFORCEMENT = "CONSISTENT_REINFORCEMENT",
  INTERNAL_INCONSISTENCY = "INTERNAL_INCONSISTENCY",
  SYNERGISTIC_ALIGNMENT = "SYNERGISTIC_ALIGNMENT",
  ACTIVE_UNDERMINING = "ACTIVE_UNDERMINING",
}

export enum LinkageType {
  THEMATIC_ALIGNMENT = "THEMATIC_ALIGNMENT",
  COMPLEMENTARY_ACTION = "COMPLEMENTARY_ACTION",
  ESCALATION_PATH = "ESCALATION_PATH",
  ISOLATED_ACTIVITY = "ISOLATED_ACTIVITY",
}

export enum SequenceFlow {
  ENGAGEMENT_PRECEDES_VOTE = "ENGAGEMENT_PRECEDES_VOTE",
  VOTE_PRECEDES_ENGAGEMENT = "VOTE_PRECEDES_ENGAGEMENT",
  BIDIRECTIONAL = "BIDIRECTIONAL",
}

export interface EngagementVotingMappingSummary {
  total_mappings: number;
  avg_confidence_score: number;
  consistent_reinforcement_count: number;
  internal_inconsistency_count: number;
  escalation_path_count: number;
  thematic_alignment_count: number;
}

// Display names for enums
export const INTERACTION_CLASS_DISPLAY: Record<InteractionClass, string> = {
  [InteractionClass.CONSISTENT_REINFORCEMENT]: "Consistent Reinforcement",
  [InteractionClass.INTERNAL_INCONSISTENCY]: "Internal Inconsistency",
  [InteractionClass.SYNERGISTIC_ALIGNMENT]: "Synergistic Alignment",
  [InteractionClass.ACTIVE_UNDERMINING]: "Active Undermining",
};

export const LINKAGE_TYPE_DISPLAY: Record<LinkageType, string> = {
  [LinkageType.THEMATIC_ALIGNMENT]: "Thematic Alignment",
  [LinkageType.COMPLEMENTARY_ACTION]: "Complementary Action",
  [LinkageType.ESCALATION_PATH]: "Escalation Path",
  [LinkageType.ISOLATED_ACTIVITY]: "Isolated Activity",
};

export const SEQUENCE_FLOW_DISPLAY: Record<SequenceFlow, string> = {
  [SequenceFlow.ENGAGEMENT_PRECEDES_VOTE]: "Engagement → Vote",
  [SequenceFlow.VOTE_PRECEDES_ENGAGEMENT]: "Vote → Engagement",
  [SequenceFlow.BIDIRECTIONAL]: "Bidirectional",
};
